import $ from 'jquery';
import CheckboxService from '../service/CheckboxService';

$('.control-checkbox').click(function () {
    const id = $(this).parents('.control').attr('data-id');
    const value = CheckboxService.getValue(id);
    CheckboxService.setValue(id, !value);
});
